import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import bindAll from 'lodash/bindAll'
import { Map } from 'immutable'
import Initializers from '../../../dependencies/initializers'
import { usersResendVerificationEmailRequest } from '../../../actions/users'
import {
	globalHideSweetAlert,
	globalAddSweetAlertData
} from '../../../actions/global'
type Props = {
	userTempEmail: Map<string, any>,
	usersResendVerificationEmailRequest: Function,
	globalHideSweetAlert: Function,
	globalAddSweetAlertData: Function
};
class UserRegisterWizardFormThirdPageNew extends React.Component<Props> {
	constructor(props) {
		super(props)

		bindAll(this, [
			'handleLoginClick', 'handleResendVerificationEmailClick'
		])
	}

	handleLoginClick(e) {
		e.preventDefault()

		
			window.location = Initializers.api_host+'/auth/login'
	
	}

	handleResendVerificationEmailClick(e) {
		e.preventDefault()

		const {
			userTempEmail,
			usersResendVerificationEmailRequest,
			globalHideSweetAlert,
			globalAddSweetAlertData
		} = this.props
		console.log('resendEmail', userTempEmail);
		usersResendVerificationEmailRequest(userTempEmail.get('email'))
		.then(()=>{
			globalAddSweetAlertData({
				show: true,
				title: 'Please Verify Your Email',
				text: "Your ASTRNT account has been successfully created. Check your email to confirm your account",
				confirmButtonText: 'OK',
				confirmButtonColor: '#564FDB',
				showLoaderOnConfirm: true,
				onConfirm: () => {
					globalHideSweetAlert()
					window.location = Initializers.api_host+'/auth/login'
				}
			})
		})
	}

	render() {
		const {userTempEmail} = this.props
		return(
			<Fragment>
				<div className="tit-reg tit-reg-verify">You're almost in!</div>
		        <div className="text-success-top">
					<p>We’ve sent a confirmation email to <b>{userTempEmail.get('email')}</b><br/>Please check your inbox and click the link to activate your Free Plan account.</p>
					<p>After verification, you will receive free credits so you can start exploring ASTRNT Platform immediately.</p>
					<p>If you don’t see the email, check your spam or junk folder.</p>
	            </div>
	            <div className="center text-success-bottom">
	              <p>Still not there?</p>
				  <div>
					<button onClick={this.handleResendVerificationEmailClick}>Resend Email</button>
					<Link to={`/candidate-support`}>Contact Support</Link>
				  </div>
	            </div>
			</Fragment>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		userTempEmail: state.userTempEmail
	}
}
const mapDispatchToProps = (dispatch) => {
	return {
		usersResendVerificationEmailRequest: (email) => dispatch(usersResendVerificationEmailRequest(email)),
		globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
	}
}
export default connect(mapStateToProps,mapDispatchToProps)(UserRegisterWizardFormThirdPageNew)
